<template>
  <div>
    <h3 class="support_details-title">
      {{ details.question }}
    </h3>
    <div
      v-html="details.details"
      class="support_details-html"
    >
    
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
  name: 'SupportDetails',
  computed: {
    ...mapGetters({
      details: 'getSupportDetails'
    })
  }
}
</script>
<style lang="scss" scoped>
  .support_details {
    &-title {
      margin: 0;
      margin-bottom: 40px;
    }
  }
</style>